var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "miniStepper" } }, [
    _c(
      "div",
      { staticClass: "container" },
      _vm._l(_vm.count, function (page, index) {
        return _c(
          "div",
          {
            class: _vm.activeIndex >= index ? "item active" : "item",
            on: {
              click: function ($event) {
                return _vm.itemlickHandler(index)
              },
            },
          },
          [
            _vm._v("\n            " + _vm._s(index + 1) + "\n            "),
            index !== 0 ? _c("div", { staticClass: "stick" }) : _vm._e(),
          ]
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }